import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { OverviewEngineFactories } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";

import { UpcomingDeadlinesOverviewEngine } from "./components/upcomingDeadlinesOverviewEngine";
import { DashboardSaga } from "./dashboardSagas";

const dashboardModule = (): Module => ({
	id: "dashboardModule",
	views: () => viewComponentProvider,
	sagas: () => [DashboardSaga],
	dataProviders: () => []
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	OverviewEngineView: OverviewEngineFactories.ViewComponent,
	UpcomingDeadlinesOverviewEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default dashboardModule;
